// const server = "http://localhost";
// const domain = "localhost";
// const port = 9465;
const server = "https://apielgocho.mansolutions.app";
const port = 443;
const domain = "elgocho.mansolutions.app";
export { server, port, domain };
